import strLen from './strLen'
/**
 * 根据指定要求长度截取字符串
 * @param {str} str 源字符串
 * @param {number} sumlength 要求字符长度
 * @returns 截取拼接后的字符串
 */
const longstrFormat = (str = '', sumlength=10) => {
  let length = strLen(str).characterStrLen
  if (length > sumlength) {
    let len = 0 //累加字符长度值
    let resultStr = ''//输出字符串

    let patrn = /[\u4E00-\u9FFF]/
    for (let item of str) {
      // 判断是英文还是中文
      let isChinese = patrn.test(item)
      if (len < 9) {
        resultStr = `${resultStr}${item}`
       len +=(isChinese ? 2 : 1)
       console.log(`%cresult:${resultStr}len:${len}`,'color:blue')
      }else if (len === 9) {
        resultStr = !isChinese ? `${resultStr}${item}` : resultStr
        console.log(resultStr)
        return resultStr+'...'
      }else{
        return resultStr+'...'
      }
    }
  } else {
    return str
  }
}
export default longstrFormat
